// import React, { useState } from "react";
// import { Document, Page, pdfjs } from "react-pdf";
// import { PDFViewer } from '@react-pdf/renderer';
// pdfjs.GlobalWorkerOptions.workerSrc = `//cdnjs.cloudflare.com/ajax/libs/pdf.js/${pdfjs.version}/pdf.worker.js`;
// const axios = require('axios');

// const PdfViewer = (props) => {
//    const getPDF = (e) => {
//     return axios(e, {
//        method: 'GET'
//     }).then((res) => {
//      console.log(res.data)

//       setPdfFile( res);
//     });
//   };

//   const [numPages, setNumPages] = useState(null);
//   const [pageNumber, setPageNumber] = useState(1); //setting 1 to show fisrt page
//   console.log(props.location.params.detail)
//   const [pdfFile, setPdfFile]=useState(null);

//       function onDocumentLoadSuccess({ numPages }) {
//             setNumPages(numPages);
//             setPageNumber(1);
//           }

//           function changePage(offset) {
//             setPageNumber(prevPageNumber => prevPageNumber + offset);
//           }

//           function previousPage() {
//             changePage(-1);
//           }

//           function nextPage() {
//             changePage(1);
//           }
//           var  pdf  = props.location.params.detail;
//             // pdf=pdf.replace('https://firebasestorage.googleapis.com/',"")

//   return (

//       <>
//         <Document
//           url = {() => getPDF(pdf)}
//           options={{workerSrc:pdfjs.GlobalWorkerOptions.workerSrc}}
//           onLoadError={console.error}
//           onLoadSuccess={onDocumentLoadSuccess}
//         >
//           <Page pageNumber={pageNumber} />
//         </Document>
//         <div>
//           <p>
//             Page {pageNumber || (numPages ? 1 : "--")} of {numPages || "--"}
//           </p>
//           <button type="button" disabled={pageNumber <= 1} onClick={previousPage}>
//             Previous
//           </button>
//           <button
//             type="button"
//             disabled={pageNumber >= numPages}
//             onClick={nextPage}
//           >
//             Next
//           </button>
//         </div>
//       </>
//     );
//   }

// export default PdfViewer

// import React from "react";
// import './styles.css'
// const PdfViewer = (props) => {
//   var pdf = props.location.params.url;
//   var name = props.location.params.name;
//   pdf = pdf + "#toolbar=0";
//   const iframe = document.getElementById('pdf');
// // iframe.contentWindow.body.addEventListener('click',() => console.log('click))
//   return (
//     <>
//     {/* <div className="wrapper"> */}
//       <h2 style={{textAlign: "center",}}>{name}</h2>
// {/*
//       <div class="embed-cover">
//       </div> */}
//       <embed id="pdf" src={pdf} type="application/pdf" height="100%" width="100%" ></embed>

//       {/* // </div> */}
//     </>
//   );
// };

// export default PdfViewer;

import React, { useEffect, useState, useRef, useCallback } from "react";
import { Button, CssBaseline, Fab } from "@material-ui/core";
import ArrowBackIcon from "@material-ui/icons/ArrowBack";
import ArrowForwardIcon from "@material-ui/icons/ArrowForward";
import * as pdfjsLib from "pdfjs-dist/build/pdf.js";
import pdfjsWorker from "pdfjs-dist/build/pdf.worker.entry.js";
import axios from "axios";

// styles
import useStyles from "./styles.js";
import "./styles.css";
import { async } from "@firebase/util";

const PdfViewer = (props) => {
  var classes = useStyles();

  var url = props.location.params.url;
  // url = url.replace("https://", "");
    React.useEffect(() => {
      axios
          .get(url)
          .then(function (response) {
              console.log(response);
          })
          .catch(function (error) {
              console.log(error);
          });
  });
  // var url = "https://cors-anywhere.herokuapp.com/"+original;

  console.log(url)
  const canvasRef = useRef();
  pdfjsLib.GlobalWorkerOptions.workerSrc =
    "https://unpkg.com/pdfjs-dist@2.14.305/build/pdf.worker.min.js";

  const [pdfRef, setPdfRef] = useState();
  const [currentPage, setCurrentPage] = useState(1);

  const renderPage = useCallback(
    (pageNum, pdf = pdfRef) => {
      pdf &&
        pdf.getPage(pageNum).then(function (page) {
          const viewport = page.getViewport({ scale: 1.5 });
          const canvas = canvasRef.current;
          canvas.height = viewport.height;
          canvas.width = viewport.width;
          const renderContext = {
            canvasContext: canvas.getContext("2d"),
            viewport: viewport,
          };
          page.render(renderContext);
        });
    },
    [pdfRef]
  );

  useEffect(() => {
    renderPage(currentPage, pdfRef);
  }, [pdfRef, currentPage, renderPage]);

  useEffect(() => {
    const loadingTask = pdfjsLib.getDocument(url);
    loadingTask.promise.then(
      (loadedPdf) => {
        setPdfRef(loadedPdf);
      },
      function (reason) {
        console.error(reason);
      }
    );
  }, [url]);

  const nP = async () =>
    pdfRef && currentPage < pdfRef.numPages && setCurrentPage(currentPage + 1);

  const pP = async () => currentPage > 1 && setCurrentPage(currentPage - 1);

  document.getElementsByClassName("pdf").oncontextmenu = function (e) {
    e.preventDefault();
    e.stopPropagation();
  };

  return (
    <div className={classes.container}>
      <CssBaseline />
      <div className={classes.pdfcontainer}>
        <canvas
          className={classes.pdfdiv}
          onContextMenu={(e) => e.preventDefault()}
          ref={canvasRef}
        ></canvas>
      </div>
      <div className={classes.arrows}>
        <Fab color="primary" aria-label="add" onClick={pP}>
          <ArrowBackIcon />
        </Fab>
        <Fab color="secondary" aria-label="edit" onClick={nP}>
          <ArrowForwardIcon />
        </Fab>
      </div>
    </div>
  );
};

export default PdfViewer;
